(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/fp/set', '../util/lodashFpConvert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/fp/set'), require('../util/lodashFpConvert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.set, global.lodashFpConvert);
    global.set = mod.exports;
  }
})(this, function (exports, _set2, _lodashFpConvert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.set = undefined;

  var _set3 = _interopRequireDefault(_set2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Sets the value at <code>path</code> of <code>object</code>.
   * This is the <code>lodash/fp</code> <code>set</code>, with no arguments rearranging and no currying.
   * @function
   * @memberof object
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {*} value The value to set.
   * @return {Object} Returns the updated object.
   * @example set({ nested: { prop: 'old' } }, 'nested.prop', 'new') // => { nested: { prop: 'new' } }
   * @see {@link https://lodash.com/docs#set|lodash.set} for more information.
   * @since 0.1.5
   */
  var set = (0, _lodashFpConvert.lodashFpConvert)(_set3.default);
  exports.set = set;
  exports.default = set;
});